(function () {
  'use strict';

  var FORM_SELECTOR =
    '.template-page-product-recall [data-form-root] shopify-forms-embed';

  var HELPER_COPY = {
    productPhoto:
      'Upload a clear photo of you holding the recalled book. Make sure the book title and cover are visible.',
    batchCode:
      'The batch code is the 8-digit number printed below the barcode on the back cover, eg: 01202601.'
  };

  var observedRoots = new WeakSet();

  function addDescription(input, helperId) {
    var describedBy = (input.getAttribute('aria-describedby') || '')
      .split(/\s+/)
      .filter(Boolean);

    if (describedBy.indexOf(helperId) === -1) {
      describedBy.push(helperId);
      input.setAttribute('aria-describedby', describedBy.join(' '));
    }
  }

  function createHelper(root, id, text, placement) {
    var existing = root.getElementById(id);
    if (existing) return existing;

    var helper = document.createElement('p');
    helper.id = id;
    helper.className = 'mbi-recall-form-helper mbi-recall-form-helper--' + placement;
    helper.textContent = text;
    return helper;
  }

  function addStyles(root) {
    if (root.querySelector('style[data-mbi-recall-form-helpers]')) return;

    var style = document.createElement('style');
    style.setAttribute('data-mbi-recall-form-helpers', '');
    style.textContent =
      '.mbi-recall-form-helper{' +
      'color:#5f5f5f;' +
      "font:normal 400 14px/1.45 'Figtree',sans-serif;" +
      'text-align:left;' +
      '}' +
      '.mbi-recall-form-helper--upload{' +
      'margin:5px 0 0;' +
      '}' +
      '.mbi-recall-form-helper--field{' +
      'margin:-6px 0 2px;' +
      '}';
    root.appendChild(style);
  }

  function enhanceProductPhoto(root) {
    var inputs = root.querySelectorAll('input[type="file"][aria-label]');

    Array.prototype.forEach.call(inputs, function (input, index) {
      if (!/product\s*(photo|image)|book\s*(photo|image)/i.test(input.getAttribute('aria-label'))) {
        return;
      }

      var wrapper = input.closest('div');
      while (wrapper && !wrapper.querySelector(':scope > p')) {
        wrapper = wrapper.parentElement;
      }
      if (!wrapper) return;

      var heading = wrapper.querySelector(':scope > p');
      var helperId = 'mbi-recall-product-photo-help-' + index;
      var helper = createHelper(
        root,
        helperId,
        HELPER_COPY.productPhoto,
        'upload'
      );

      if (!helper.isConnected) heading.insertAdjacentElement('afterend', helper);
      addDescription(input, helperId);
    });
  }

  function enhanceBatchCode(root) {
    var inputs = root.querySelectorAll('input[type="text"]');

    Array.prototype.forEach.call(inputs, function (input, index) {
      var labelId = input.getAttribute('aria-labelledby');
      var label = labelId ? root.getElementById(labelId) : null;
      var labelText = label ? label.textContent.trim() : '';

      if (!/batch\s*code/i.test(labelText)) return;

      var field = input.parentElement;
      if (!field || !field.parentElement) return;

      var helperId = 'mbi-recall-batch-code-help-' + index;
      var helper = createHelper(
        root,
        helperId,
        HELPER_COPY.batchCode,
        'field'
      );

      if (!helper.isConnected) field.insertAdjacentElement('afterend', helper);
      addDescription(input, helperId);
    });
  }

  function enhanceHost(host) {
    var root = host.shadowRoot;
    if (!root) return;

    addStyles(root);
    enhanceProductPhoto(root);
    enhanceBatchCode(root);

    if (!observedRoots.has(root)) {
      observedRoots.add(root);
      new MutationObserver(function () {
        enhanceHost(host);
      }).observe(root, { childList: true, subtree: true });
    }
  }

  function scan() {
    document.querySelectorAll(FORM_SELECTOR).forEach(enhanceHost);
  }

  new MutationObserver(scan).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  window.addEventListener('pageshow', scan);
  scan();

  var attempts = 0;
  var hydrationTimer = window.setInterval(function () {
    scan();
    attempts += 1;
    if (attempts >= 40) window.clearInterval(hydrationTimer);
  }, 250);
})();
